<template>
  <div>
    CONFIGURACOES
  </div>
</template>

<script>
export default {
  methods: {
    data() {
      return {
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    }
  },
  beforeCreate() { }
};
</script>

<style>
</style>